import {Component, EventEmitter, Input, OnInit, Output, QueryList, ViewChildren} from '@angular/core';
import {IExceptionDatesModal, IExceptionTable, ITimetable} from '../../models/timetable';
import {fadeInAnimation} from '../../animations/fade-in.animation';
import {addDays as _addDays, addHours as _addHours, differenceInMinutes} from 'date-fns';
import {MessageAlertService} from '../../services/message-alert/message-alert.service';
import {TimetableService} from '../../services/timetable/timetable.service';
import {Logger} from '../../class/helper/logger.class';
import {cloneDeep} from 'lodash';
import {SetHoursComponent} from '../set-hours/set-hours.component';
import {PLATFORM_CONFIG} from '../../config/platform.config';

@Component({
  selector: 'app-set-hours-and-exceptions',
  templateUrl: './set-hours-and-exceptions.component.html',
  styleUrls: ['./set-hours-and-exceptions.component.scss'],
  animations: [fadeInAnimation]
})
export class SetHoursAndExceptionsComponent implements OnInit {
  // tslint:disable:no-redundant-jsdoc
  @Input() scheduleGroupId: string;
  @Input() disabled = false;
  @Input() days: ITimetable[] = [];
  @Input() exceptions: IExceptionTable[] = [];
  @Output() addTimetable: EventEmitter<any> = new EventEmitter();
  @Output() changeTimetable: EventEmitter<any> = new EventEmitter();
  @Output() save: EventEmitter<any> = new EventEmitter<any>();
  @ViewChildren(SetHoursComponent) hours: QueryList<SetHoursComponent>;
  isVisibleAddNewDateException: boolean;
  datesException: IExceptionDatesModal;
  platformConfig = PLATFORM_CONFIG;
  constructor(
    private messageAlertService: MessageAlertService,
    private timetableService: TimetableService
  ) { }

  ngOnInit(): void {
    this.cleanModalAddException();
  }

  cleanModalAddException(): void {
    this.datesException = cloneDeep({
      dates: [new Date(), _addDays(new Date(), 1)],
      recurrent: false,
      hours: []
    });
  }

  onAddTimetable(day: number): void {
    if (day >= 0 && day <= 6) {
      const newHour = {
        startHour: 0,
        startMinutes: 0,
        endHour: 0,
        endMinutes: 0,
        duration: 0
      };
      // this.days.push({
      //   day,
      //   hourTable: [newHour]
      // });
      this.days = [...this.days, {
        day,
        hourTable: [newHour]
      }];
      this.addTimetable.emit(this.days);
      this.changeTimetable.emit(new Date());
    }
  }

  onChange(): void {
    this.changeTimetable.emit(new Date());
  }

  /**
   * de acuerdo con el modal de crear una excepcion, se agrega una nueva excepcion al arreglo de excepciones
   */
  addException(): void {
    this.exceptions.push({
      start: {
        day: this.datesException.dates[0].getDate(),
        month: this.datesException.dates[0].getMonth(),
        year: this.datesException.dates[0].getFullYear()
      },
      end: {
        day: this.datesException.dates[1].getDate(),
        month: this.datesException.dates[1].getMonth(),
        year: this.datesException.dates[1].getFullYear()
      },
      recurrent: this.datesException.recurrent,
      hourTable: this.datesException.hours.map(item => {
        return {
          startHour: item.start.getHours(),
          startMinutes: item.start.getMinutes(),
          endHour: item.end.getHours(),
          endMinutes: item.end.getMinutes(),
          duration: differenceInMinutes(item.end, item.start)
        };
      })
    });
    this.cleanModalAddException();
  }

  /**
   * Elimina una exception junto con sus horarios
   * @param index
   */
  removeException(index: number): void {
    if (!this.disabled) {
      this.exceptions.splice(index, 1);
      this.changeTimetable.emit(new Date());
    }
  }

  /**
   * agrega un nuevo conjunto de horario (inicio-fin) a la excepcion
   */
  addHourGroupToException(): void {
    if (this.datesException.hours && Array.isArray(this.datesException.hours)) {
      this.datesException.hours.push({
        start: new Date(),
        end: _addHours(new Date(), 1),
      });
    }
  }

  /**
   * elimina un conjunto de horario (inicio-fin) de una excepcion
   * @param index
   */
  removeHourGroupToException(index: number): void {
    this.datesException.hours.splice(index, 1);
  }

  /**
   * cuando se cierra el modal de crear excepcion se determina si se crea una nueva o solo se limpia el modal
   * @param value
   */
  closeModalAddNewDateException(value: boolean): void {
    if (!value) {
      this.cleanModalAddException();
      this.isVisibleAddNewDateException = false;
      return;
    }
    if (this.datesException.dates && this.datesException.hours.length > 0) {
      // verificar que las horas estén validadas
      try {
        this.timetableService.checkExceptionDateTimeRange(this.datesException, true);
        this.timetableService.checkExceptionTimeRanges(this.datesException, true);
        this.timetableService.checkExceptionTimeSplicing(this.datesException, true);
        this.addException();
        this.changeTimetable.emit(new Date());
        this.isVisibleAddNewDateException = false;
      } catch (e) {
        Logger.log('Ocurrió un error', e?.message);
      }
    } else {
      this.messageAlertService.createMessage('error', 'Es requerido tener horarios para la excepción');
    }
  }

  /**
   * se envian los datos para la creacion de un grupo de horarios y excepciones
   */
  onSave(): void {
    if (!this.disabled) {
      const days = cloneDeep(this.hours.map(item => {
        return item.timetable;
      }));
      this.days = cloneDeep(days.filter(day => day));
      this.save.emit({
        scheduleGroupId: this.scheduleGroupId,
        days: this.days,
        exceptions: this.exceptions
      });
    }
  }

  /**
   * se abre el modal para crear nueva exception
   */
  openModalNewException(): void {
    if (!this.disabled) {
      this.isVisibleAddNewDateException = true;
    }
  }
}
